import { mergeStyleSets } from '@uifabric/merge-styles/lib/index';
/**
 * Creates a getClassNames function which calls getStyles given the props, and injects them
 * into mergeStyleSets.
 */
export function classNamesFunction() {
    // TODO: memoize.
    return function (getStyles, styleProps) { return mergeStyleSets(getStyles && getStyles(styleProps)); };
}
//# sourceMappingURL=classNamesFunction.js.map